/* PARCU - collection controls. One bar holding View all, Sort by
   and Filters. It sits in the flow where the theme's filter
   dropdown was, and once that position has scrolled away it
   becomes a floating pill at the foot of the window.

   All three open the same frosted sheet, each with its own group
   expanded. The sheet does not rebuild the filters: the theme's
   own form is moved into it, so the swatches, the price slider and
   every input stay exactly what the theme rendered, and every
   label stays whatever parcu-i18n.js has made of it.

   Applying is the theme's own: its form is a GET with no action,
   so submitting it reloads the collection with the facets in the
   query string, which is exactly how Shopify filtering works. The
   theme's Clear all and Apply are moved into the sheet to drive
   that. Nothing applies on change; you press Apply.

   The count is the whole collection, not the page: Liquid puts
   window.PARCU_CCOUNT on the page because the grid only ever holds
   what has been paginated in so far.

   Phones only. */
(function () {
    'use strict';
    var SMALL = '(max-width: 777px)';
    var sheet = null;

    function small() { return window.matchMedia(SMALL).matches; }
    function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }
    function txt(n) { return n ? n.textContent.trim() : ''; }

    function total() {
        if (typeof window.PARCU_CCOUNT === 'number' && window.PARCU_CCOUNT > 0) return window.PARCU_CCOUNT;
        return document.querySelectorAll('.product-grid product-card').length || 0;
    }

    /* ---- the sheet ------------------------------------------- */

    function openSheet(which) {
        if (!sheet) return;
        if (which === 'cats') ensureCats();
        var groups = sheet.body.querySelectorAll('details');
        for (var i = 0; i < groups.length; i++) {
            var key = groups[i].getAttribute('data-parcu-g');
            groups[i].open = which === 'all' ? groups[i].open : (key === which);
        }
        sheet.wrap.classList.add('is-on');
        document.documentElement.classList.add('parcu-fs-open');
    }

    function closeSheet() {
        if (!sheet) return;
        sheet.wrap.classList.remove('is-on');
        document.documentElement.classList.remove('parcu-fs-open');
    }

    /* The sort select becomes a row of pills, the select kept and
       hidden so its value is still what the form submits. */
    function sortPills(group) {
        var sel = group.querySelector('select[name="sort_by"]');
        if (!sel || group.querySelector('.parcu-fs__pills')) return;
        var box = el('div', 'parcu-fs__pills');
        var mark = function () {
            var bs = box.children;
            for (var i = 0; i < bs.length; i++) {
                bs[i].classList.toggle('is-on', bs[i].getAttribute('data-v') === sel.value);
            }
        };
        for (var i = 0; i < sel.options.length; i++) {
            (function (opt) {
                var b = el('button', 'parcu-fs__pill');
                b.type = 'button';
                b.setAttribute('data-v', opt.value);
                b.textContent = opt.textContent.trim();
                b.addEventListener('click', function () { sel.value = opt.value; mark(); });
                box.appendChild(b);
            })(sel.options[i]);
        }
        mark();
        sel.parentNode.insertBefore(box, sel);
        group.classList.add('parcu-fs__sortgroup');
    }

    /* parcu-header.js builds the category bar, and may not have run
       when this bar was assembled, so the group waits until asked. */
    function ensureCats() {
        if (!sheet || sheet.body.querySelector('[data-parcu-g="cats"]')) return;
        var bar = document.querySelector('.parcu-subbar');
        if (!bar || !bar.querySelectorAll('a').length) return;
        sheet.body.insertBefore(catGroup(bar), sheet.body.firstChild);
    }

    /* The category list, which is not part of the facets form. */
    function catGroup(bar) {
        var g = el('details', 'parcu-fs__group');
        g.setAttribute('data-parcu-g', 'cats');
        /* parcu-subbar.js publishes the family this page belongs
           to, so a hoodie collection is not headed Heavyweight
           tees. The menu's first family is the fallback. */
        var fam = (window.PARCU_SUBFAM && window.PARCU_SUBFAM.label) || '';
        var s = el('summary', 'parcu-fs__sum');
        s.textContent = fam
            || txt(document.querySelector('#mobmenu .menus ul > li summary'))
            || txt(document.querySelector('.listing-page h1, main h1'));
        g.appendChild(s);
        var list = el('div', 'parcu-fs__cats');
        var as = bar.querySelectorAll('a');
        for (var i = 0; i < as.length; i++) {
            var a = el('a', 'parcu-fs__cat');
            a.href = as[i].getAttribute('href');
            a.textContent = txt(as[i]);
            if (as[i].classList.contains('is-on') || as[i].hasAttribute('aria-current')) a.classList.add('is-on');
            list.appendChild(a);
        }
        g.appendChild(list);
        return g;
    }

    /* Only used by the fallback footer below. */
    function applyUrl(form) {
        var q = [], fd = new FormData(form), seen = {};
        fd.forEach(function (v, k) {
            if (v === '' || v === null) return;
            if (k !== 'sort_by' && k.indexOf('filter.') !== 0) return;
            var pair = encodeURIComponent(k) + '=' + encodeURIComponent(v);
            if (seen[pair]) return;
            seen[pair] = 1;
            q.push(pair);
        });
        return location.pathname + (q.length ? '?' + q.join('&') : '');
    }

    function buildSheet(details, form) {
        var wrap = el('div', 'parcu-fs');
        var box = el('div', 'parcu-fs__box');

        var head = el('div', 'parcu-fs__head');
        var h = el('p', 'parcu-fs__title');
        h.textContent = txt(details.querySelector(':scope > summary')) || 'Filters';
        var x = el('button', 'parcu-fs__x');
        x.type = 'button';
        x.setAttribute('aria-label', 'Close');
        x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
            + '<path d="M5 5 19 19M19 5 5 19" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
        x.addEventListener('click', closeSheet);
        head.appendChild(h);
        head.appendChild(x);

        var body = el('div', 'parcu-fs__body');

        /* The theme's own form, moved rather than copied. The
           category group is added later: the bar it is built from
           may not exist yet. */
        body.appendChild(form);
        var gs = form.querySelectorAll(':scope > details');
        for (var i = 0; i < gs.length; i++) {
            gs[i].classList.add('parcu-fs__group');
            var sum = gs[i].querySelector(':scope > summary');
            if (sum) {
                /* The theme's summary carries a caret of its own,
                   which would collide with the sheet's chevron. */
                sum.className = '';
                sum.classList.add('parcu-fs__sum');
            }
            gs[i].setAttribute('data-parcu-g', i === 0 ? 'sort' : 'f' + i);
            gs[i].open = false;
            if (i === 0) sortPills(gs[i]);
        }

        /* The theme ships its own Clear all and Apply at the foot of
           the form, already wired and already translated, so they
           are moved into the sheet rather than replaced. Apply is a
           submit button and the move takes it out of the form, so
           it is reattached by id. The hand rolled pair below is the
           fallback for a theme that does not have them. */
        var foot = el('div', 'parcu-fs__foot');
        var themeFoot = form.querySelector(':scope > x-grid');
        if (themeFoot) {
            var sub = themeFoot.querySelector('button[type="submit"]');
            if (sub && form.id) sub.setAttribute('form', form.id);
            foot.appendChild(themeFoot);
        } else {
            var clear = el('button', 'parcu-fs__clear');
            clear.type = 'button';
            clear.textContent = 'Clear all';
            clear.addEventListener('click', function () { location.href = location.pathname; });
            var apply = el('button', 'parcu-fs__apply');
            apply.type = 'button';
            apply.textContent = 'Apply filters';
            apply.addEventListener('click', function () { location.href = applyUrl(form); });
            foot.appendChild(clear);
            foot.appendChild(apply);
        }

        box.appendChild(head);
        box.appendChild(body);
        box.appendChild(foot);
        wrap.appendChild(box);
        wrap.addEventListener('click', function (e) { if (e.target === wrap) closeSheet(); });
        document.body.appendChild(wrap);

        sheet = { wrap: wrap, body: body, form: form };
    }

    /* ---- the bar --------------------------------------------- */

    function build() {
        var block = document.querySelector('.filterBlock');
        if (!block || block.getAttribute('data-parcu-cbar')) return;
        if (!small()) return;
        var details = block.querySelector('details.filter');
        var form = document.getElementById('FacetFiltersFormMobile');
        if (!details || !form) return;

        var bar = el('div', 'parcu-cbar');
        var pill = el('div', 'parcu-cbar__pill');
        bar.appendChild(pill);

        var cats = document.querySelector('.parcu-subbar');
        var viewBtn = el('button', 'parcu-cbar__view');
        viewBtn.type = 'button';
        var viewLabel = cats ? (cats.querySelector('a.is-on, a[aria-current]') || cats.querySelector('a')) : null;
        var h1 = document.querySelector('.listing-page h1, main h1');
        var vt = el('span', 'parcu-cbar__viewtxt');
        vt.textContent = txt(viewLabel) || txt(h1);
        var vc = el('sup', 'parcu-cbar__count');
        vc.textContent = total() || '';
        var vi = el('i', 'parcu-cbar__caret');
        viewBtn.appendChild(vt); viewBtn.appendChild(vc); viewBtn.appendChild(vi);
        pill.appendChild(viewBtn);

        var sortSum = form.querySelector(':scope > details > summary');
        var sortBtn = el('button', 'parcu-cbar__sort');
        sortBtn.type = 'button';
        sortBtn.textContent = txt(sortSum) || 'Sort by';
        pill.appendChild(sortBtn);

        var filtBtn = el('button', 'parcu-cbar__filters');
        filtBtn.type = 'button';
        filtBtn.textContent = txt(details.querySelector(':scope > summary')) || 'Filters';
        pill.appendChild(filtBtn);

        var anchor = el('div', 'parcu-cbar__anchor');
        block.appendChild(anchor);
        block.appendChild(bar);
        block.setAttribute('data-parcu-cbar', '1');
        block.classList.add('parcu-cbar-on');

        buildSheet(details, form);

        viewBtn.addEventListener('click', function () { openSheet('cats'); });
        sortBtn.addEventListener('click', function () { openSheet('sort'); });
        filtBtn.addEventListener('click', function () { openSheet('all'); });

        function onScroll() {
            bar.classList.toggle('is-float', anchor.getBoundingClientRect().top < 0);
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
    }

    function start() {
        build();
        window.addEventListener('resize', build);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
        if (!window.MutationObserver) return;
        var t;
        new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 80); })
            .observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else { start(); }
})();
